/**
 * A vehicle object.
 *
 * @property {number} [averageFuelConsumption] - The average fuel consumption calculated in l/100km
 * @property {ObjectColors} [color] - The color of the object
 * @property {ObjectControlFlags[]} [controlFlags] - A limited selection of control flags of the object
 * @property {number} [course] - The current course of the object in degree (between 0 and 359)
 * @property {number} [customVehicleFuelConsumption] - The user configured value for fuel consumption (l/100km)
 * @property {string} [destination] - The vehicle destination
 * @property {Position} [destinationPosition] - The position of the destination
 * @property {ISO8601} [eta] - The ETA in ISO-8601 format
 * @property {number} [engineTotalFuelUsage] - The current total fuel usage in milliliters of a vehicle, which might be null, zero or other integer.
 * @property {FuelTypes} [fuelType] - Fuel type
 * @property {ObjectFuelUsages} [fuelUsagePreference] - Indicates which field has the fuel consumption information
 * @property {number} [gearShiftRpm] - Optimum gear shift rpm (between 1 and 99999)
 * @property {boolean} [ignitionOn] - Indicates whether the ignition is on
 * @property {Id} [imageid] - Id of user selected image
 * @property {TelematicDeviceAccessory} [lastConnectedTachograph] - The connection data of the last connected tachograph
 * @property {ISO8601} [lastGpsTime] - The last GPS time in ISO-8601 format
 * @property {number} [lastModified] - The last-modified timestamp of the object
 * @property {string} [licensePlate] - The license plate (maximum length: 50)
 * @property {ISO3166Country} [licensePlateCountryCode] - The license plate country code (maximum length: 2)
 * @property {ISO3166Subdivision} [licensePlateFederalStateCode] - The license plate federal state code (maximum length: 3)
 * @property {LocationDescription} [locationDescription] - Reverse geocoded position descriptions (New geocoder)
 * @property {LogBookModes} [logbookMode] - The logbook mode
 * @property {string} [name] - The name of the object, unique within an account (between 1 and 50)
 * @property {string} [number] - The number of the object, unique within an account (between 1 and 10)
 * @property {string} [objectClass] - The object class of an object
 * @property {Id} [objectId] - The ID of the object
 * @property {number} [odometer] - The odometer of the vehicle in meter, with a precision of 100m, rounded down
 * @property {Position} [position] - The current position of the object
 * @property {Id} [positionAddressId] - The ID of the address at the position of the object. Can be used with '/'addresses/{addressId}' to obtain the actual address
 * @property {number} [speed] - The current vehicle speed
 * @property {number} [speedLimit] - The speed limit of the vehicle in kph (maximum: 10000)
 * @property {boolean} [standStill] - Indicates whether the object is standing still (true) or not (false)
 * @property {ISO8601} [standstillMsgTime] - The standstill position time, in ISO-8601 format
 * @property {StealthModes} [stealthMode] - The stealth mode
 * @property {ISO8601} [stealthModeMsgTime] - The stealth mode message time in ISO-8601 format
 * @property {TripModes} [tripMode] - The trip mode (this field is deprecated, use logbookMode instead)
 * @property {ObjectTypes} [type] - Type ONTARIO used to render the vehicle icon - NOT the type in vehicleSpecification.type!
 * @property {VehicleGeneration} vehicleGeneration - Vehicle generation details
 * @property {string} [vin] - The vehicle identification number
 * @property {VehicleUsageType} vehicleUsageType - The vehicle usage type for driver assignment
 */
export class VehicleObject {}
